import { render, staticRenderFns } from "./PaginaBilancioCoccia.vue?vue&type=template&id=dc0e6566"
import script from "./PaginaBilancioCoccia.vue?vue&type=script&lang=js"
export * from "./PaginaBilancioCoccia.vue?vue&type=script&lang=js"
import style0 from "./PaginaBilancioCoccia.vue?vue&type=style&index=0&id=dc0e6566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports